export class Stat {
  emptyTriggered = false;
  current = 0;
  constructor(
    public max: number,
    private trigger?: null | ((params?: any) => void),
    startFull?: boolean
  ) {
    if (startFull) {
      this.current = max;
    }
  }

  change(value: number) {
    if (0 < value) {
      this.emptyTriggered = false;
      this.current = Math.min(this.max, this.current + value);
    } else {
      this.current = Math.max(0, this.current + value);
    }
    if (!this.current && this.trigger && !this.emptyTriggered) {
      this.emptyTriggered = true;
      this.trigger();
    }
  }

  adjustMax(value: number, fill?: boolean) {
    this.max = Math.max(0, this.max + value);
    if (!fill) {
      this.current = Math.min(this.max, this.current);
    } else {
      this.emptyTriggered = false;
      this.change(value);
    }
  }

  fill() {
    this.emptyTriggered = false;
    this.current = this.max;
  }
}
